export default "__VITE_ASSET__d6ec7378__"